"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.calculateFees = void 0;
var cryptoassets_1 = require("@ledgerhq/cryptoassets");
var bignumber_js_1 = require("bignumber.js");
var invariant_1 = __importDefault(require("invariant"));
var errors_1 = require("@ledgerhq/errors");
var errors_2 = require("../../../errors");
var shared_1 = require("../../../bridge/shared");
var types_1 = require("../types");
var scanAccounts_1 = require("../../../libcore/scanAccounts");
var syncAccount_1 = require("../../../libcore/syncAccount");
var cache_1 = require("../../../cache");
var account_1 = require("../../../account");
var libcore_broadcast_1 = __importDefault(require("../libcore-broadcast"));
var libcore_signOperation_1 = __importDefault(require("../libcore-signOperation"));
var getFeesForTransaction_1 = require("../../../libcore/getFeesForTransaction");
var access_1 = require("../../../libcore/access");
var getCoreAccount_1 = require("../../../libcore/getCoreAccount");
var buildBigNumber_1 = require("../../../libcore/buildBigNumber");
var tokens_1 = require("../tokens");
var logic_1 = require("../logic");
var jsHelpers_1 = require("../../../bridge/jsHelpers");
var errors_3 = require("../../../errors");
var receive = (0, jsHelpers_1.makeAccountBridgeReceive)();
exports.calculateFees = (0, cache_1.makeLRUCache)(function (_a) {
    var a = _a.a, t = _a.t;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, (0, getFeesForTransaction_1.getFeesForTransaction)({
                        account: a,
                        transaction: t
                    })];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    });
}, function (_a) {
    var a = _a.a, t = _a.t;
    return "".concat(a.id, "_").concat(t.amount.toString(), "_").concat(t.recipient, "_").concat(String(t.useAllAmount), "_").concat(t.memo ? t.memo.toString() : "", "_").concat(t.mode, "_").concat(t.assetId || "");
});
var getSpendableMaxForOptIn = function (account) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, access_1.withLibcore)(function (core) { return __awaiter(void 0, void 0, void 0, function () {
                    var coreAccount, algorandAccount, spendableBalanceBigInt, spendableBalance;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, (0, getCoreAccount_1.getCoreAccount)(core, account)];
                            case 1:
                                coreAccount = (_a.sent()).coreAccount;
                                return [4 /*yield*/, coreAccount.asAlgorandAccount()];
                            case 2:
                                algorandAccount = _a.sent();
                                return [4 /*yield*/, algorandAccount.getSpendableBalance(types_1.AlgorandOperationTypeEnum.ASSET_OPT_IN)];
                            case 3:
                                spendableBalanceBigInt = _a.sent();
                                return [4 /*yield*/, (0, buildBigNumber_1.libcoreAmountToBigNumber)(spendableBalanceBigInt)];
                            case 4:
                                spendableBalance = _a.sent();
                                return [2 /*return*/, spendableBalance];
                        }
                    });
                }); })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var createTransaction = function () { return ({
    family: "algorand",
    amount: new bignumber_js_1.BigNumber(0),
    fees: null,
    recipient: "",
    useAllAmount: false,
    memo: null,
    mode: "send",
    assetId: null
}); };
var updateTransaction = function (t, patch) {
    return __assign(__assign({}, t), patch);
};
var recipientHasAsset = function (assetId, recipient, account) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, access_1.withLibcore)(function (core) { return __awaiter(void 0, void 0, void 0, function () {
                    var coreAccount, algorandAccount, hasAsset;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, (0, getCoreAccount_1.getCoreAccount)(core, account)];
                            case 1:
                                coreAccount = (_a.sent()).coreAccount;
                                return [4 /*yield*/, coreAccount.asAlgorandAccount()];
                            case 2:
                                algorandAccount = _a.sent();
                                return [4 /*yield*/, algorandAccount.hasAsset(recipient, assetId)];
                            case 3:
                                hasAsset = _a.sent();
                                return [2 /*return*/, hasAsset];
                        }
                    });
                }); })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var getAmountValid = function (recipient, amount, account) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, access_1.withLibcore)(function (core) { return __awaiter(void 0, void 0, void 0, function () {
                    var coreAccount, algorandAccount, isValid;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, (0, getCoreAccount_1.getCoreAccount)(core, account)];
                            case 1:
                                coreAccount = (_a.sent()).coreAccount;
                                return [4 /*yield*/, coreAccount.asAlgorandAccount()];
                            case 2:
                                algorandAccount = _a.sent();
                                return [4 /*yield*/, algorandAccount.isAmountValid(recipient, amount.toString())];
                            case 3:
                                isValid = _a.sent();
                                return [2 /*return*/, isValid];
                        }
                    });
                }); })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/*
 * Here are the list of the differents things we check
 * - Check if recipient is the same in case of send
 * - Check if recipient is valid
 * - Check if amounts are set
 * - Check if fees are loaded
 * - Check if is a send Max and set the amount
 * - Check if Token is already optin at the recipient
 * - Check if memo is too long
 */
var getTransactionStatus = function (a, t) { return __awaiter(void 0, void 0, void 0, function () {
    var errors, warnings, tokenAccount, _a, recipientError, recipientWarning, estimatedFees, amount, totalSpent, _b, _c, _d, spendableBalance;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                errors = {};
                warnings = {};
                tokenAccount = !t.subAccountId
                    ? null
                    : a.subAccounts && a.subAccounts.find(function (ta) { return ta.id === t.subAccountId; });
                if (!(t.mode === "send" && a.freshAddress === t.recipient)) return [3 /*break*/, 1];
                errors.recipient = new errors_1.InvalidAddressBecauseDestinationIsAlsoSource();
                return [3 /*break*/, 3];
            case 1: return [4 /*yield*/, (0, shared_1.validateRecipient)(a.currency, t.recipient)];
            case 2:
                _a = _e.sent(), recipientError = _a.recipientError, recipientWarning = _a.recipientWarning;
                if (recipientError) {
                    errors.recipient = recipientError;
                }
                if (recipientWarning) {
                    warnings.recipient = recipientWarning;
                }
                _e.label = 3;
            case 3:
                estimatedFees = t.fees || new bignumber_js_1.BigNumber(0);
                amount = t.amount;
                totalSpent = estimatedFees;
                _b = t.mode;
                switch (_b) {
                    case "send": return [3 /*break*/, 4];
                    case "optIn": return [3 /*break*/, 9];
                    case "claimReward": return [3 /*break*/, 11];
                }
                return [3 /*break*/, 12];
            case 4:
                if (amount.lte(0) && !t.useAllAmount) {
                    errors.amount = new errors_1.AmountRequired();
                }
                if (!t.fees || !t.fees.gt(0)) {
                    errors.fees = new errors_1.FeeNotLoaded();
                }
                _c = tokenAccount &&
                    tokenAccount.type === "TokenAccount" &&
                    !errors.recipient;
                if (!_c) return [3 /*break*/, 6];
                return [4 /*yield*/, recipientHasAsset((0, tokens_1.extractTokenId)(tokenAccount.token.id), t.recipient, a)];
            case 5:
                _c = !(_e.sent());
                _e.label = 6;
            case 6:
                if (_c) {
                    errors.recipient = new errors_2.AlgorandASANotOptInInRecipient();
                }
                amount = t.useAllAmount
                    ? tokenAccount
                        ? tokenAccount.balance
                        : a.spendableBalance.minus(estimatedFees)
                    : amount;
                if (amount.lt(0)) {
                    amount = new bignumber_js_1.BigNumber(0);
                }
                totalSpent = tokenAccount ? amount : amount.plus(estimatedFees);
                _d = !errors.recipient;
                if (!_d) return [3 /*break*/, 8];
                return [4 /*yield*/, getAmountValid(t.recipient, amount, a)];
            case 7:
                _d = !(_e.sent());
                _e.label = 8;
            case 8:
                if (_d) {
                    errors.amount = new errors_1.NotEnoughBalanceBecauseDestinationNotCreated("", {
                        minimalAmount: "0.1 ALGO"
                    });
                }
                if (!tokenAccount && amount.gt(0) && estimatedFees.times(10).gt(amount)) {
                    warnings.feeTooHigh = new errors_1.FeeTooHigh();
                }
                if ((amount.lte(0) && t.useAllAmount) || // if use all Amount sets an amount at 0
                    (!errors.recipient && !errors.amount && tokenAccount
                        ? totalSpent.gt(tokenAccount.balance)
                        : totalSpent.gt(a.spendableBalance)) // if spendable balance lower than total
                ) {
                    errors.amount = new errors_1.NotEnoughBalance();
                }
                // if spendable balance lower than fees for token
                if (!errors.amount &&
                    tokenAccount &&
                    a.spendableBalance.lt(estimatedFees)) {
                    errors.amount = new errors_1.NotEnoughBalanceInParentAccount();
                }
                return [3 /*break*/, 12];
            case 9:
                if (!t.fees || !t.fees.gt(0)) {
                    errors.fees = new errors_1.FeeNotLoaded();
                }
                // This error doesn't need to be translate,
                // it will use to block until the user choose an assetId
                if (!t.assetId) {
                    errors.assetId = new Error("Asset Id is not set");
                }
                return [4 /*yield*/, getSpendableMaxForOptIn(a)];
            case 10:
                spendableBalance = _e.sent();
                if (spendableBalance.lt(estimatedFees)) {
                    errors.amount = new errors_1.NotEnoughBalance();
                }
                return [3 /*break*/, 12];
            case 11:
                {
                    if (a.spendableBalance.lt(totalSpent)) {
                        errors.amount = new errors_1.NotEnoughBalance();
                    }
                    (0, invariant_1["default"])(a.algorandResources, "Algorand family");
                    if (estimatedFees.gt(a.algorandResources.rewards)) {
                        warnings.claimReward = new errors_3.ClaimRewardsFeesWarning();
                    }
                    return [3 /*break*/, 12];
                }
                _e.label = 12;
            case 12:
                if (t.memo && t.memo.length > logic_1.ALGORAND_MAX_MEMO_SIZE) {
                    throw new Error("Memo is too long");
                }
                return [2 /*return*/, Promise.resolve({
                        errors: errors,
                        warnings: warnings,
                        estimatedFees: estimatedFees,
                        amount: amount,
                        totalSpent: totalSpent
                    })];
        }
    });
}); };
var sameFees = function (a, b) { return (!a || !b ? a === b : a.eq(b)); };
var prepareTransaction = function (a, t) { return __awaiter(void 0, void 0, void 0, function () {
    var fees, amount, recipient, errors, res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                fees = t.fees;
                amount = t.amount;
                recipient = t.recipient;
                if (t.mode === "optIn" || t.mode === "claimReward") {
                    recipient = a.freshAddress;
                    amount = new bignumber_js_1.BigNumber(0);
                }
                if (!(recipient || t.mode !== "send")) return [3 /*break*/, 3];
                return [4 /*yield*/, (0, shared_1.validateRecipient)(a.currency, recipient)];
            case 1:
                errors = (_a.sent()).recipientError;
                errors = errors || (t.mode === "optIn" && !t.assetId);
                if (!!errors) return [3 /*break*/, 3];
                return [4 /*yield*/, (0, exports.calculateFees)({
                        a: a,
                        t: t
                    })];
            case 2:
                res = _a.sent();
                fees = res.estimatedFees;
                _a.label = 3;
            case 3:
                if (!sameFees(t.fees, fees) ||
                    !sameFees(t.amount, amount) ||
                    t.recipient !== recipient) {
                    return [2 /*return*/, __assign(__assign({}, t), { fees: fees, amount: amount, recipient: recipient })];
                }
                return [2 /*return*/, t];
        }
    });
}); };
var estimateMaxSpendable = function (_a) {
    var account = _a.account, parentAccount = _a.parentAccount, transaction = _a.transaction;
    return __awaiter(void 0, void 0, void 0, function () {
        var mainAccount, t, s;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    mainAccount = (0, account_1.getMainAccount)(account, parentAccount);
                    return [4 /*yield*/, prepareTransaction(mainAccount, __assign(__assign(__assign(__assign({}, createTransaction()), { subAccountId: account.type === "Account" ? null : account.id }), transaction), { recipient: (transaction === null || transaction === void 0 ? void 0 : transaction.recipient) || (0, cryptoassets_1.getAbandonSeedAddress)(mainAccount.currency.id), useAllAmount: true }))];
                case 1:
                    t = _b.sent();
                    return [4 /*yield*/, getTransactionStatus(mainAccount, t)];
                case 2:
                    s = _b.sent();
                    return [2 /*return*/, s.amount];
            }
        });
    });
};
var preload = function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, Promise.resolve({})];
}); }); };
var hydrate = function () { };
var currencyBridge = {
    preload: preload,
    hydrate: hydrate,
    scanAccounts: scanAccounts_1.scanAccounts
};
var accountBridge = {
    createTransaction: createTransaction,
    updateTransaction: updateTransaction,
    prepareTransaction: prepareTransaction,
    getTransactionStatus: getTransactionStatus,
    sync: syncAccount_1.sync,
    receive: receive,
    signOperation: libcore_signOperation_1["default"],
    broadcast: libcore_broadcast_1["default"],
    estimateMaxSpendable: estimateMaxSpendable
};
exports["default"] = {
    currencyBridge: currencyBridge,
    accountBridge: accountBridge
};
//# sourceMappingURL=libcore.js.map